exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".product-quarantined Button{margin:30px 0 10px}.product-quarantined .after-order-button-text{margin-top:1em}.product-quarantined .under30{font-weight:600}", "", {"version":3,"sources":["/home/bamboo/applications/bamboo-home/xml-data/build-dir/AAI-SCFR-JOB1/src/page-components/src/page-components/ProductQuarantined.scss"],"names":[],"mappings":"AAEA,4BAGI,kBAAmB,CAHvB,8CAOI,cAAe,CAPnB,8BAUI,eAAgB,CACjB","file":"ProductQuarantined.scss","sourcesContent":["@import '../styles/colors';\n\n.product-quarantined {\n\n  Button {\n    margin: 30px 0 10px;\n  }\n\n  .after-order-button-text {\n    margin-top: 1em;\n  }\n  .under30 {\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/sass-loader/lib/loader.js?sourceMap!./src/page-components/ProductQuarantined.scss
// module id = 1386
// module chunks = 0